import React from 'react'

import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {Grid} from '@vio/atlas/helpers/Grid'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const RoomDetailsSectionSkeleton = () => {
  return (
    <Box paddingTop="s500">
      <Box display="flex" flexDirection="column" gap="s600">
        <div>
          <SkeletonLoader width={80} />
          <Box
            display="flex"
            justifyContent="space-between"
            gap="s500"
            marginTop="s300"
          >
            <SkeletonLoader width={150} />
            <SkeletonLoader width={80} marginTop={0} />
          </Box>
        </div>
        <SkeletonLoader width={150} marginTop={0} />
      </Box>
      <Box paddingTop="s500" paddingBottom="s500">
        <RoomPriceSkeleton />
      </Box>
      <Divider />
    </Box>
  )
}

export const RoomPriceSkeleton = () => {
  return (
    <Grid container spacing="s000" alignItems="center" justify="space-between">
      <SkeletonLoader width={150} />
      <SkeletonLoader width={80} marginTop={0} />
    </Grid>
  )
}

/** Room section with the "Your room" heading (`showYourRoomHeading`) */
export const YourRoomSkeleton = ({withDivider = false}) => (
  <>
    <Box paddingTop="s500" paddingBottom="s500" data-id="YourRoomSkeleton">
      <SkeletonLoader width={152} />
      <SkeletonLoader width={82} />
    </Box>
    {withDivider && <Divider />}
  </>
)
